import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="mt-5">
      <div className="container py-4">
        <div className="row">
          <div className="col-md-4 mb-4 mb-md-0">
            <h5 className="text-uppercase mb-3">Sterling Tax Solutions</h5>
            <p>Providing professional tax services to individuals and businesses.</p>
          </div>
          
          <div className="col-md-4 mb-4 mb-md-0">
            <h5 className="text-uppercase mb-3">Contact Us</h5>
            <p>
              <i className="bi bi-telephone-fill me-2"></i>
              <a href="tel:+15195752836">+1 519-575-2836</a>
            </p>
            <p>
              <i className="bi bi-envelope-fill me-2"></i>
              <a href="mailto:Abhishek.Deswal@sterlingtax.ca">Abhishek.Deswal@sterlingtax.ca</a>
            </p>
            <p>
              <i className="bi bi-envelope-fill me-2"></i>
              <a href="mailto:info@sterlingtax.ca">info@sterlingtax.ca</a>
            </p>
          </div>

          <div className="col-md-4">
            <h5 className="text-uppercase mb-3">Quick Links</h5>
            <ul className="list-unstyled">
              <li><Link to="/services">Our Services</Link></li>
              <li><Link to="/appointments">Book an Appointment</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>
        </div>
        
        <hr className="my-4" />
        
        <div className="row">
          <div className="col-12 text-center">
            <p className="mb-0">© {currentYear} Sterling Tax Solutions. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 